import { Input } from 'antd';
import { useEffect, useRef, useState } from 'react';
import SendIcon from '../../Assets/send.png';
import SendDisabledIcon from '../../Assets/sendDisabled.png';
import { askAI } from '../../Utils/getAiResponse';
import './chatbot.scss';

const questions = [
  'Who is Puneet Sharma?',
  'What skills does Puneet have?',
  'What projects has Puneet worked on?',
  'How can I contact Puneet?',
]

const Chatbot = ({ setShowChatbot, resumeText }) => {

  const [tab, setTab] = useState('home');
  const [inputValue, setInputValue] = useState('');

  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const scrollContainerRef = useRef(null);

  // function to scroll to bottom of chat messages
  const scrollToBottom = () => {
    if (!scrollContainerRef?.current) return;
    scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight;
  }

  useEffect(() => {
    scrollToBottom();
  }, [messages, isLoading])

  // function to go back to chatbot home
  const handleBackClick = () => {
    setTab('home');
    setInputValue('');
  }

  // function to close chatbot
  const handleCloseChatbot = () => {
    setShowChatbot(false);
    setTimeout(() => {
      setTab('home');
    }, 200);
  }

  // onchange function for chatbot input field
  const handleInputChange = (e) => {
    setInputValue(e?.target?.value);
  }

  // on click function for pre defined questions
  const handleQuestionsClick = (ques) => {
    setInputValue(ques);
    setTab('chat');
  }

  // const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  // function to send message to chatbot
  const handleSendMessage = async () => {
    if (!inputValue?.trim() || isLoading) return;

    const question = inputValue;

    // add user message
    setMessages(prev => [
      ...prev,
      { role: 'user', text: question }
    ]);

    setInputValue('');
    setIsLoading(true);

    try {
      const answer = await askAI(question, resumeText);

      setMessages(prev => [
        ...prev,
        { role: 'assistant', text: answer }
      ]);
    }
    catch (error) {
      console.log('Error while receiving response from chatbot', error);
      setMessages(prev => [
        ...prev,
        { role: 'assistant', text: 'Something went wrong. Please try again.' }
      ]);
    }
    finally {
      setIsLoading(false);
    }
  }

  return (
    <div style={{ minWidth: '24rem', maxWidth: '24rem', position: 'relative' }}>

      {/* Global close icon */}
      <div style={{ position: 'absolute', right: '1rem', top: '0.9rem' }}>
        <span class="material-symbols-outlined" style={{ color: tab === 'home' ? '#fff' : 'gray', cursor: 'pointer' }} onClick={handleCloseChatbot}>
          close
        </span>
      </div>

      {tab === 'home' ?
        // Homepage section
        <div className='chatbot-container'>
          <div className='header'>
            <h3 className='heading'>Hi there!</h3>
            <p className='description'>How can we help you today?</p>
          </div>

          <div className='questions'>
            {questions?.map((item) => {
              return (
                <div key={item} className='content' onClick={() => handleQuestionsClick(item)}>
                  <p style={{ fontSize: '0.85rem', fontWeight: 300 }}>{item}</p>
                  <span class="material-symbols-outlined" style={{ fontSize: '0.8rem' }}>arrow_forward_ios</span>
                </div>
              )
            })}
          </div>

          <div className='have-questions'>
            <div className='content' onClick={() => setTab('chat')}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <h2 style={{ fontSize: '0.85rem', fontWeight: 300 }}>Have questions?</h2>
                <p style={{ fontSize: '0.73rem', color: '#788097' }}>We are here to assist you.</p>
              </div>

              <span class="material-symbols-outlined" style={{ fontSize: '0.8rem' }}>arrow_forward_ios</span>
            </div>
          </div>

          <div className='tabs-container'>
            <div style={{ display: 'flex', flexDirection: 'column', cursor: 'pointer', alignItems: 'center', }}>
              <span class="material-symbols-outlined" style={{ fontSize: '1.5rem', color: tab === 'home' ? 'orange' : '788097' }}>
                home
              </span>
              <p style={{ fontSize: '0.75rem', fontWeight: 500, }}>Home</p>
            </div>

            <div className='chat-icon-hover' style={{ display: 'flex', flexDirection: 'column', cursor: 'pointer', alignItems: 'center' }} onClick={() => setTab('chat')}>
              <span class="material-symbols-outlined" style={{ fontSize: '1.5rem', color: '#788097' }}>
                chat_bubble
              </span>
              <p style={{ fontSize: '0.75rem', fontWeight: 500 }}>Chat</p>
            </div>
          </div>

          <div className='powered-by'>
            <p>Powered by Google Gemini</p>
          </div>
        </div>
        :
        // Chats section
        <div className='chat-container'>
          <div className='header'>
            <span class="material-symbols-outlined" style={{ fontSize: '1rem', color: '#788097', cursor: 'pointer' }} onClick={handleBackClick}>
              arrow_back_ios
            </span>
            <p className='heading'>Hi there!</p>
          </div>

          <div className='chat-messages' ref={scrollContainerRef}>
            {messages?.map((item, index) => {
              return (
                <div key={index} className={item?.role === 'user' ? 'sent' : 'received'}>
                  <p>{item?.text}</p>
                </div>
              )
            })}

            {isLoading && (
              <div className='received'>
                <p>Typing…</p>
              </div>
            )}
          </div>

          <div className='input-container'>
            <Input.TextArea placeholder='Enter your message...' value={inputValue}
              onChange={handleInputChange} autoSize={{ minRows: 1.2, maxRows: 3 }} />

            <img alt='' src={inputValue?.length > 0 ? SendIcon : SendDisabledIcon} style={{ width: '1.4rem', height: '1.4rem', cursor: 'pointer' }} onClick={handleSendMessage} />
          </div>
        </div>
      }
    </div>
  )
}

export default Chatbot;
